import styled from "styled-components";

const FarmerStats = styled.div`
  font-family: "Poppins";
  text-align: center;
  align-items: center;
  color: white;
  background-color: #163940;
  .wrapper {
    .title {
      transform: translateX(-100%);
      transition: 2s ease;
      padding-top: 2em;
      color: white;
      font-family: Poppins;
      font-size: 40px;
      font-style: normal;
      font-weight: 300;
      line-height: 60px;
      letter-spacing: 0em;
      text-align: center;
      &.fadeIn {
        transform: translateX(0%);
        opacity: 1;
      }
      @media (max-width: 1700px) {
        font-size: 34px;
      }

      @media (max-width: 800px) {
        font-size: 30px;
      }
      @media (max-width: 600px) {
        font-size: 26px;
      }
    }
    .stats {
      display: flex;
      justify-content: space-around;
      padding: 0em 3em 2em 3em;
      @media (max-width: 750px) {
        flex-wrap: wrap;
      }
      .stat {
        @media (max-width: 750px) {
          flex: 15vw;
          padding: 0.5em;
        }
        h3 {
          color: #fdcd0b;
          font-family: Poppins;
          font-size: 44px;
          font-style: normal;
          font-weight: 300;
          line-height: 66px;
          letter-spacing: 0em;
          text-align: center;

          @media (max-width: 1700px) {
            font-size: 35px;
          }
          @media (max-width: 600px) {
            font-size: 26px;
          }
        }
        p {
          font-family: Poppins;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 27px;
          letter-spacing: 0em;
          text-align: center;

          @media (max-width: 1700px) {
            font-size: 14px;
          }
        }
      }
    }
  }
`;

export default FarmerStats;
